// lib/deploy/clientEpoch.ts
//
// ÉPOCA DE CLIENTE — cómo se marca un deploy como NECESARIO (S5-1, P1-15).
//
// Las tablets de operador (POS, KDS, kiosko, display) ya NO se recargan solas
// durante el servicio por cada deploy: con 40-50 deploys al día eso eran ~40
// arranques en frío por tablet. Solo se recargan fuera del horario del local
// (lib/deploy/serviceWindow.ts), por un error de desfase de versión
// (lib/deploy/versionSkew.ts), o cuando el deploy vivo declara que los bundles
// viejos YA NO SIRVEN. Esa declaración es este número.
//
// Cada bundle compila su CLIENT_EPOCH y lo manda en `GET /api/build-id?epoch=N`.
// El servidor responde `required: true` si N < su propio CLIENT_EPOCH, y la
// tablet recarga en el siguiente momento sin uso aunque el local esté abierto
// (respetando cobros/impresiones en curso, holdReload).
//
// CUÁNDO SUBIRLO (en el MISMO PR del cambio, +1):
//   - una ruta /api/* que el cliente llama con fetch cambia de contrato
//     (Skew Protection de Vercel NO cubre esas rutas, solo actions/RSC/chunks);
//   - una migración quita o renombra algo que el cliente lee con supabase-js;
//   - un fix de cliente que no puede esperar a la noche (cobro mal, comanda
//     que no sale).
// NO subirlo por cambios normales: el fix llega solo cuando el local cierra.
//
// Por qué un archivo y no una variable de entorno: una env MAYOR que la época
// compilada haría que el bundle NUEVO también se viera viejo → bucle de
// recargas. Con el archivo, el bundle nuevo siempre trae la época del deploy.
export const CLIENT_EPOCH = 1

/** `?epoch=` del query → entero ≥ 0, o null si falta o no es un entero sano. */
export function parseClientEpoch(raw: string | null): number | null {
  if (raw === null || !/^\d{1,6}$/.test(raw)) return null
  return Number(raw)
}

export interface BuildIdPayload {
  /** VERCEL_DEPLOYMENT_ID del deploy vivo ("dev" en local). */
  id: string
  /** Época mínima que acepta el deploy vivo. */
  minEpoch: number
  /** La tablet que preguntó tiene un bundle que este deploy ya no soporta. */
  required: boolean
}

export function buildIdPayload(a: {
  deploymentId: string | undefined
  clientEpoch: number | null
  minEpoch: number
}): BuildIdPayload {
  const id = a.deploymentId || "dev"
  // Sin epoch = bundle anterior a S5-1: no sabe leer `required` y su lógica
  // vieja sigue igual; no hay nada que decirle.
  const required = id !== "dev" && a.clientEpoch !== null && a.clientEpoch < a.minEpoch
  return { id, minEpoch: a.minEpoch, required }
}
